import { ColorHex, LoadingDots } from '@carboncopyco/ui';
import classNames from 'classnames';
import { useEffect, useMemo, useState } from 'react';

type CoverImageLoaderProps = {
  url: string;
  fileServiceApiToken: string;
};

export const CoverImageLoader = ({
  url,
  fileServiceApiToken,
}: CoverImageLoaderProps) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const imageUrl = useMemo(
    () => `${url}?token=${fileServiceApiToken}`,
    [url, fileServiceApiToken]
  );

  useEffect(() => {
    const image = new Image();
    image.src = imageUrl;

    image.onload = () => {
      setImageLoaded(true);
    };

    return () => {
      setImageLoaded(false);
    };
  }, [imageUrl]);

  return (
    <div
      className={classNames(
        'flex w-full h-full relative min-h-[35px] min-w-[91px] items-center justify-center',
        { 'rounded-lg shadow-ds-lg': imageLoaded }
      )}
    >
      <img
        src={imageUrl}
        className={classNames({ hidden: !imageLoaded })}
        style={{ width: '100%', height: 'fit-content' }}
      />
      <div
        className={classNames(
          'flex w-full h-full absolute justify-center items-center',
          {
            'bg-white bg-opacity-70': imageLoaded,
          }
        )}
      >
        <LoadingDots color={ColorHex.natural600} />
      </div>
    </div>
  );
};
